/**
 * The colours a view may be given in the view switcher.
 *
 * Every entry is a member of `BASEROW_COLORS` in
 * `backend/src/baserow/core/constants.py`, which is what the API validates
 * `View.color` against -- so anything offered here is accepted. Note that
 * `green` is NOT a member despite existing in the frontend `$colors` map, so
 * it cannot be offered here however natural it looks in the sequence below.
 *
 * ONE SWATCH PER HUE. `BASEROW_COLORS` carries 27 names, but they are nine
 * hues in three tints each (`light-blue`, `blue`, `dark-blue`), and a tint is
 * not a distinction the eye makes on a 16px glyph -- offering all 27 shows the
 * user three times as many swatches as there are outcomes. Airtable's enum is
 * built the same way (10 hues x 5 tiers) and its UI likewise spends one hue
 * per item rather than exposing the tiers as separate choices; Notion's icon
 * palette drops the tiers entirely, ten named colours with no tint tier
 * (https://developers.notion.com/reference/emoji-and-icon). The unprefixed
 * tint is the one kept because it is the middle of the three, so the name a
 * user picks ("blue") is the colour they get.
 *
 * ORDERED BY HUE, not by name. Airtable lists its palette
 * blue -> cyan -> teal -> green -> yellow -> orange -> red -> pink -> purple
 * -> gray, i.e. around the spectrum with the neutral last
 * (https://airtable.com/developers/web/api/field-model). The order below is
 * that sequence intersected with what the API accepts: `teal` and `green` are
 * absent from `BASEROW_COLORS` and `brown` is present where Airtable has none,
 * so brown sits with the warm hues it belongs to. Sequenced this way the row
 * reads as a spectrum instead of an arbitrary pile.
 *
 * What each name RESOLVES to on an icon is a separate question, handled by
 * `view-color--*` in `views_panel.scss`: the `$colors` entries behind these
 * names are background tints and are far too pale to see as a glyph.
 */
export const VIEW_COLORS = [
  'blue',
  'cyan',
  'yellow',
  'orange',
  'brown',
  'red',
  'pink',
  'purple',
  'gray',
]

export default VIEW_COLORS
